window.activateAbSiv002 = () => {
    // add bestseller items list
    const bestsellerItem = document.querySelector(".menu-drawer__panel-body li:has(> a[href='/pages/bestseller'])");

    if (!bestsellerItem) return;
    
    const bestsellers = [
        {
            title: "Leggings",
            category: "Umstandsmode",
            image_url: "https://cdn.shopify.com/s/files/1/0764/5092/2833/files/Rectangle_8_2.png?v=1773196198",
            url: "/products/sivara-schwangerschafts-leggings"
        },
        {
            title: "Shorts",
            category: "Umstandsmode",
            image_url: "https://cdn.shopify.com/s/files/1/0764/5092/2833/files/Rectangle_8_3.png?v=1773196198",
            url: "/products/schwangerschafts-shorts"
        },
        {
            title: "Komfort-BH",
            category: "Unterwäsche",
            image_url: "https://cdn.shopify.com/s/files/1/0764/5092/2833/files/Rectangle_8_4.png?v=1773196199",
            url: "/products/sivara-komfort-bh-naht-und-buegellos"
        },
        {
            title: "Tangas",
            category: "Unterwäsche",
            image_url: "https://cdn.shopify.com/s/files/1/0764/5092/2833/files/Rectangle_8_5.png?v=1773196198",
            url: "/products/seamless-komfort-tangas"
        }
    ];
    const markup = `
        <li class="menu-drawer__bestsellers">
            ${bestsellers.map(bestseller => `
                <a href="${bestseller.url}" class="menu-drawer__bestseller-item">
                    <img class="menu-drawer__bestseller-item__image" src="${bestseller.image_url}" alt="${bestseller.title}">
                    <div class="menu-drawer__bestseller-item__text">
                        <span class="menu-drawer__bestseller-item__category">${bestseller.category}</span>
                        <span class="menu-drawer__bestseller-item__title">${bestseller.title}</span>
                    </div>
                </a>
            `).join('')}
        </li>
    `;

    document.body.setAttribute('data-ab-siv-002', '');

    bestsellerItem.insertAdjacentHTML('afterend', markup);

    // change spring sale list item position
    const springSaleItem = document.querySelector(".menu-drawer__panel-body li:has(> a[href='/collections/black-week-sale'])");
    const pregnancyFashionItem = document.querySelector(".menu-drawer__panel-body li:has(> a[href='/collections/schwangerschaft'])");

    if (!springSaleItem || !pregnancyFashionItem) return;

    pregnancyFashionItem.after(springSaleItem);
};

// document.addEventListener('DOMContentLoaded', () => {
// 	window.activateAbSiv002();
// });